import { getUsagePeriodUsageRpc } from '../../../../../__generated__/chirp/com/hubspot/usagebasedbilling/experience/rpc/UsageBasedBillingExperienceRpc';
import { hubfulRpcClient } from '../../../../utils/API';
export const getHubspotCreditsData = () => {
  return hubfulRpcClient.call(getUsagePeriodUsageRpc, {
    request: {
      showBreakdown: true
    }
  });
};